import React, { Component } from 'react';
import { connect } from 'react-redux';

import Image from './Image';

import {selectSquare, addSquare, removeSquare, targetSquare, alterSquare, popStar, addGoal} from '../actions';
import { getSquares, getSquaresHierarchy } from '../selectors';

const squarePlaceMapping = [
  [0,0],
  [0,1],
  [0,2],
  [1,0],
  [1,2],
  [2,0],
  [2,1],
  [2,2]
];

class Square extends Component {

  renderSquare(square_id, xOffset, yOffset) {

    return (
      <SquareWrapper
        key       = {square_id}
        width     = {this.props.width / 3}
        height    = {this.props.height / 3}
        xOffset   = {xOffset}
        yOffset   = {yOffset}
        square_id  = {square_id}
      />
    )
  }

  renderDirection(direction) {
    if (direction === -1) {
      return 'facing left';
    }
    else if (direction === 0) {
      return 'upside down'
    }
    else if (direction === 1) {
      return 'facing right'
    }
  }

  renderDepth(depth) {
    if (depth === 1) {
      return 'big';
    }
    else if (depth === 2) {
      return 'medium'
    }
    else if (depth === 3) {
      return 'small'
    }
  }

  renderDepthFontSize(depth) {
    if (depth === 1) {
      return '1000%';
    }
    else if (depth === 2) {
      return '400%'
    }
    else if (depth === 3) {
      return '100%'
    }
  }

  render() {

    if (this.props.squares === undefined || this.props.children === undefined) {
      return null;
    }

    const square = this.props.square || this.props.squares[this.props.square_id];

    if ( square === undefined ) { return null }

    const children = this.props.children;

    const [xPlacement, yPlacement] = squarePlaceMapping[this.props.autoPlace ? square.idx : 0];

    const xCoord = this.props.xOffset + xPlacement * this.props.width;
    const yCoord = this.props.yOffset + yPlacement * this.props.height;

    const isDead = this.props.immortal || ! square.dead ? false : true;
    const isStar = ! this.props.immortal && square.star ? true : false;

    let editor = this.props.editor;

    if (children.length === 0 || this.props.immortal) {

      let animal;
           if (isDead)        { animal = 'sleep' }
      else if (isStar)        { animal = 'star'  }
      else if (square.empty)  { animal = undefined }
      else                    { animal = this.props.animals[square.animal] || square.animal };

      const direction = isDead || isStar
        ? 1
        : square.direction;

      let fill;
           if (isDead)       { fill = 'black';}
      else if (isStar)       { fill = 'white'}
      else if (square.fill !== undefined && (!square.empty || this.props.editor))  { fill = this.props.palette[square.fill] || square.fill }
      else                   { fill = '#555555' };

      const selectFunction = (e) => {
        //we start with the specialist of special cases. the goal tool is only used in the editor, and will only set a goal string.
        if (this.props.tool.active && this.props.tool.tool === 'goal') {
            this.props.addGoal(square);
        }
        //and we start with a special case. The alarm doesn't target anything, it only operates on dead squares
        else if (this.props.tool.active && this.props.tool.tool === 'alarm') {
          //so if we're clicking a square with the alarm active, we fall into here. But we only alter it if it's actually dead.
          if (isDead) {
            this.props.alterSquare(undefined, this.props.square_id, this.props.tool);
          }
        }
        // if we have an active tool and a target and that tool has a value, then we're alterring this square
        else if (this.props.tool.active && this.props.tool.value !== undefined) {
          this.props.alterSquare(undefined, this.props.square_id, this.props.tool);
        }
        // if it's a star and it's not the smallest, then we should toggle the star
        else if (isStar && square.depth < 3) {
          this.props.popStar({id : this.props.square_id});
        }
        // if it's an empty square and we're in the editor, do nothing
        else if (square.empty && !editor) {
          return
        }
        //otherwise, if it's not dead, not a star, and not immortal, then we have more to check
        else if (!isDead && !isStar && !this.props.immortal) {
          //if there's an active tool (which won't have a value, we checked up above)
          if (this.props.tool.active) {
            //then if there's no target, we're targeting this one
            if (this.props.target_id === undefined) {
              this.props.targetSquare(this.props.square_id);
            }
            //if there is a target, then we're altering this one
            else if (this.props.target_id !== this.props.square_id) {
              const target = this.props.squares[this.props.target_id];
              const field = this.props.tool.field;
              if (target[field] !== square[field]) {
                this.props.alterSquare( this.props.target_id, this.props.square_id, this.props.tool )
              }
            }
          }
          //finally, if we're not in the editor, then we can select it.
          else if (! editor) {
            this.props.selectSquare(this.props.square_id)
          }
        }
      };

      return (
        <g transform={`translate(${xCoord},${yCoord})`}>

          <rect
            x           = { 0 }
            y           = { 0 }
            width       = { this.props.width }
            height      = { this.props.height }
            fill        = { fill }
            stroke      = { this.props.immortal ? 'darkgray' : 'black' }
            strokeWidth = { 2 }
          />

          <rect
            x           = { 4 }
            y           = { 4 }
            width       = { this.props.width - 8 }
            height      = { this.props.height - 8 }
            fill        = { 'none' }
            stroke      = {
              this.props.isTargeted
                ? 'green'
                : square.selected && ! this.props.immortal ? 'cyan' : 'none'
            }
            strokeWidth = { 4 }
          />

          <Image
            image={ animal }
            side={ this.props.width }
            direction={ direction }
            fill={isDead ? 'lightgray' : 'black'}
          />

          <Image
            image='target'
            side={this.props.width}
            fill={'red'}
            componentProps={{opacity : 0.3, visibility : this.props.isTargeted ? 'visible' : 'hidden'}}
            />

          <g transform={`translate(0,${this.props.height / 2})`} visibility='hidden'>
            <rect fill='darkgray' x='0' y={'0'} width={this.props.width } height={'4.5em'} opacity='0.9'/>
            <text x = {20} y = {0} textAnchor = 'left' fill='white'>
              <tspan x='20' dy='1em'>Animal : { square.animal }&#x2713;</tspan>
              <tspan x='20' dy='1em'>Color : { square.fill }&#x2718;</tspan>
              <tspan x='20' dy='1em'>Direction : { this.renderDirection(direction) }</tspan>
              <tspan x='20' dy='1em'>Size : { this.renderDepth(square.depth) }</tspan>
            </text>
          </g>

          <text
            x={this.props.width / 2}
            y={this.props.height / 2}
            textAnchor='middle'
            alignmentBaseline='middle'
            fill='red'
            fontSize={`${this.renderDepthFontSize(square.depth)}`}
            visibility={this.props.immortal ? 'hidden' : 'visible'}>
            { square.deadCount }
          </text>

          { editor && square.locked && (
            <g transform={`translate(${this.props.width * 8/9}, ${this.props.height * 8/9})`}>
              <Image
                image='lock'
                side={this.props.width / 9}
                fill={'#222222'}
                componentProps={{opacity : 0.8}}
                />
            </g>
          )}

          <rect
            x           = { 0 }
            y           = { 0 }
            width       = { this.props.width }
            height      = { this.props.height }
            fill        = { 'black' }
            onClick     = { selectFunction }
            opacity     = { 0 }
          />

        </g>
      )
    }
    else {
      return children.map( square_id => this.renderSquare(square_id, xCoord, yCoord));
    }
  }
}

Square.defaultProps = {
  xOffset   : 0,
  yOffset   : 0,
  autoPlace : true,
}

const mapStateToProps = (state, props) => {

  const hierarchy = getSquaresHierarchy(state);
  const children = hierarchy[props.square_id] || [];

  return {
    squares       : getSquares(state),
    children      : children,
    tool          : state.tool,
    isTargeted    : props.square_id && state.tool.target_id === props.square_id,
    target_id     : state.tool.target_id,
    editor        : state.level && state.level.level === 'editor',
    palette       : state.level.palette || [],
    animals       : state.level.animals || [],
  }
}

const SquareWrapper = connect(mapStateToProps, {selectSquare, addSquare, removeSquare, targetSquare, alterSquare, popStar, addGoal})(Square);
export default SquareWrapper;



// WEBPACK FOOTER //
// ./src/components/Square.js